import React from "react";

import * as globalComponents from "../../../../../components";
import FiftyPercentDiscountResolutionForm from "./components/FiftyPercentDiscountResolutionForm";

import "../../styles.css";

export default function FiftyPercentDiscountResolution() {
  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs
        title="Solicitação de Desconto na Anuidade"
        dir={[]}
      />

      <div className="container">
        <globalComponents.PageTitle title="FORMULÁRIO PARA SOLICITAÇÃO DE 50% DE DESCONTO" />
        <p>
          <a
            href="https://www.coffito.gov.br/nsite/?p=36209"
            style={{ color: "var(--secondary-color)" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Resolução COFFITO Nº 635/2025
          </a>
          : Profissionais com 30 (trinta) anos de registro ou mais terão
          desconto de 50% (cinquenta porcento) para o pagamento da anuidade.
        </p>
        <div className="denuncia--container__wrapper">
          <div className="denuncia--content">
            <FiftyPercentDiscountResolutionForm />
          </div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
